import {saveLocal} from '@/assets/js/common'
import $api from '@/api/index'
// 基本模块
const baseModule = {
  state: {
    isLoading: false,
    token: '',
    menuList: [],
    userInfo: {},
    isLogin: false,
    isMaxRole: false
  },
  mutations: {
    setLoading: (state, data) => {
      state.isLoading = data
    },
    setToken: (state, data) => {
      state.token = data
      state.isLogin = true
    },
    removeToken: (state) => {
      state.token = null
      saveLocal('userToken', 'token', null)
    },
    setUserInfo: (state, data) => {
      state.userInfo = data || {}
      state.isMaxRole = data.RoleId === '0622d271-63e3-4efb-935f-e075058ac5ec'
    },
    setMenu: (state, data) => {
      state.menuList = data || []
    },
    setLogin: (state, data) => {
      state.isLogin = data
    }
  },
  actions: {
    getMenu: ({commit}) => {
      return new Promise(resolve => {
        $api.getMenu(res => {
          let newArr = res.filter(f => f['ParentId'] === '00000000-0000-0000-0000-000000000000')
          newArr.forEach(o => {
            o.children = res.filter(c => c['ParentId'] === o['Id'])
          })
          commit('setMenu', newArr)
          resolve(res)
          commit('setLoading', false)
        })
      })
    },
    getUserInfo: ({commit}) => {
      $api.getUserInfo(res => {
        commit('setUserInfo', res)
      }, () => {
        setTimeout(() => {
          commit('setLoading', false)
        }, 500)
      })
    }
  }
}

export default baseModule



// WEBPACK FOOTER //
// ./src/store/base.js